import {Component, Input} from '@angular/core';

@Component({
  selector: 'ox-family-sharing-alert',
  templateUrl: './family-sharing-alert.component.html'
})
export class FamilySharingAlertComponent {
  @Input() user:string;
}
